export enum Indicators {
	PRODUCT_COMPRESSION_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.UPDATE_COMPRESSION',
	PRODUCT_PARAMS_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.UPDATE_PARAMETERS',
	PRODUCTS_DELETED = 'PLANOGRAMS_LIST.INDICATORS.DELETE_PRODUCTS',
	ETL_PRODUCT_UPDATE = 'PLANOGRAMS_LIST.INDICATORS.DAILY_UPDATE',
	PRODUCT_ROTATION = 'PLANOGRAMS_LIST.INDICATORS.PRODUCTS_ROTATION',
	PLANOGRAM_COPY = 'PLANOGRAMS_LIST.INDICATORS.PLANOGRAM_COPY',
	EQUIPMENT_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.EDIT_EQUIPMENT',
	ARCHIVED_PRODUCTS = 'PLANOGRAMS_LIST.INDICATORS.ARCHIVED_PRODUCTS',
	UNARCHIVED_PRODUCTS = 'PLANOGRAMS_LIST.INDICATORS.UNARCHIVED_PRODUCTS'
}

export enum IndicatorsIcon {
	ERROR = 'error',
	WARNING = 'warning',
	SCHEDULED = 'scheduleSend'
}

export enum IndicatorsColor {
	ERROR = '#ff0000',
	WARNING = '#ffcc15',
	SCHEDULED = '#ff5a00'
}